/* eslint-disable */

;(function (d, a) {
    var e = d.screen.width
    var b = 750
    var c = Number(e / b)
    var f = Number(100 * c)
    a.documentElement.style.fontSize = f + 'px'
})(window, document)
